import { useEffect, useState } from "react";
import en from "./en";
import it from "./it";

const DICT = { en, it };
export const LANGS = ["en", "it"];
const stored = typeof localStorage !== "undefined" ? localStorage.getItem("dgl_lang") : null;
let current = DICT[stored] ? stored : (typeof navigator !== "undefined" && (navigator.language || "").toLowerCase().startsWith("it") ? "it" : "en");
const listeners = new Set();

export const getLang = () => current;
export const setLang = (l) => {
  current = DICT[l] ? l : "en";
  try { localStorage.setItem("dgl_lang", current); } catch {}
  listeners.forEach((f) => f(current));
};

/* t("key", { n: 3 }) — falls back to English, then to the key itself */
export const t = (key, vars) => {
  let s = DICT[current][key] ?? DICT.en[key] ?? key;
  if (vars) Object.keys(vars).forEach((k) => { s = s.split(`{${k}}`).join(vars[k]); });
  return s;
};

/* loc(MAPS.castle, "maps", "castle") — game data with the localized fields layered on top */
export const loc = (obj, table, id) => {
  const o = DICT[current].data && DICT[current].data[table] && DICT[current].data[table][id];
  return o && obj ? { ...obj, ...o } : obj;
};

export function useLang() {
  const [lang, set] = useState(current);
  useEffect(() => { listeners.add(set); return () => listeners.delete(set); }, []);
  return { lang, t, loc, setLang };
}
